// Angular
import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatChip, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';

// Models
import { CampaignDTO } from '../../../../core/models/campaignDTO.model';
import { CampaignService } from '../../../../core/services/campaign.service';
import { ActionPointsCampaignConfigurationResult } from '../../../../model/club-gigot/action-points/action-points-campaign-configuration-result.model';
import { ActionPointCampaignConfiguration } from '../../../../model/club-gigot/action-points/action-points-campaign-configuration.model';
import { ActionPointType, toActionPointTypeString } from '../../../../model/club-gigot/action-points/_enum/action-point.enum';
import { ActionPointsService } from '../../../../service/club-gigot/action-points.service';
import { Enum } from '../../../../support/enum.support';

@Component({
  selector: 'kt-dialog-copy-action-point',
  templateUrl: './dialog-copy-action-point.component.html',
  styleUrls: ['./dialog-copy-action-point.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DialogCopyActionPointComponent implements OnInit, AfterViewInit {

    public loading$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public campaigns$ : Subject<CampaignDTO[]> = new Subject<CampaignDTO[]>();
    public currentCampaignNumber : Subject<string> = new Subject<string>();

    public actionPointCreationForm : FormGroup;
    public actionPointTypes: ActionPointType[] = Enum.valuesOf(ActionPointType);

    constructor(
        private dialogRef: MatDialogRef<DialogCopyActionPointComponent>,
        private campaignService: CampaignService,
        private actionPointsService : ActionPointsService,
        @Inject(MAT_DIALOG_DATA)
        public originCampaignSequence: number,
    ) {}

    public ngOnInit() : void {  
        this.buildForm()
    }

    public ngAfterViewInit(): void {
        this.loadCampaigns();
        this.getNumberCampaign(this.originCampaignSequence);
    }

    public getNumberCampaign(campaignSequence : number) : void {
        this.campaigns$.subscribe((campaigns : CampaignDTO[]) => {
            this.currentCampaignNumber.next(campaigns.find((campaign : CampaignDTO) => campaign.sequence == campaignSequence).number)
        })
    }

    public buildForm() : void {
        this.actionPointCreationForm = new FormGroup({
            copyGroup: new FormGroup({
                campaignToCopy: new FormControl(this.originCampaignSequence, [Validators.required]),
                actionPointsToCopy : new FormControl([]),
                copyCatalog : new FormControl(false)
            }),
            destinationGroup: new FormGroup({
                campaignDestination : new FormControl(null, [Validators.required])
            })
        })
    }

    public loadCampaigns() : void {
        this.campaignService.getCampaigns().subscribe({
            next: (campaigns : CampaignDTO[]) => this.campaigns$.next(campaigns),
            error: (_ : Error) => this.campaigns$.next([])         
        });
    }

    public onNoClick(): void {
        this.dialogRef.close(true);
    }

    public toActionPointTypeString(actionPointCreationType: ActionPointType): string {
		return toActionPointTypeString(actionPointCreationType);
	}

    public isControlHasError(controlName: string, validationType: string, formGroup : string = undefined): boolean {
        const control = formGroup 
            ? this.actionPointCreationForm.get(`${formGroup}.${controlName}`)
            : this.actionPointCreationForm.get(controlName)
        if (!control) return false;      
        return control.hasError(validationType) && (control.dirty || control.touched);
    }

    public onCreateActionPointConfiguration() : void{
        if(!this.actionPointCreationForm.valid) return;
        this.loading$.next(true);
        let creationDTORequest : ActionPointCampaignConfiguration = new ActionPointCampaignConfiguration(
            this.actionPointCreationForm.get("destinationGroup.campaignDestination").value
        );
        creationDTORequest.addCopyConfiguration(
            this.actionPointCreationForm.get("copyGroup.campaignToCopy").value, 
            this.actionPointCreationForm.get("copyGroup.actionPointsToCopy").value, 
            this.actionPointCreationForm.get("copyGroup.copyCatalog").value
        );           
        this.actionPointsService.copyActionPointConfiguration(creationDTORequest).pipe(
            finalize(() => this.loading$.next(false))
        ).subscribe({
                next: (_ : any) => this.dialogRef.close(new ActionPointsCampaignConfigurationResult(true, creationDTORequest.getDestination())),
                error: (error : HttpErrorResponse) => this.dialogRef.close(new ActionPointsCampaignConfigurationResult(
                        false, creationDTORequest.getDestination(), error.error.errorMessage
                    ))         
            })
    }

    public toggleAction (value: ActionPointType, chip: MatChip) : void {
        chip.toggleSelected();  
        this.actionPointCreationForm.get("copyGroup.actionPointsToCopy").value.push(value); 
        this.actionPointCreationForm.get("copyGroup.actionPointsToCopy").updateValueAndValidity();
    }
}
